import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Personas en USA que han sido denegadas para un préstamo de auto o hipoteca.', 'Inmigrantes que están construyendo su vida y necesitan un historial sólido.', 'Cualquiera que tenga colecciones médicas injustas en su reporte.', 'Dueños de tarjetas de crédito con uno o dos pagos tarde que arruinan su promedio.'];
  const notFor = ['Quienes buscan un botón mágico para desaparecer deudas legítimas sin mover un dedo.', 'Personas que no están dispuestas a ir a la oficina postal a enviar correos certificados.', 'Quienes no viven o no tienen actividad crediticia dentro de los Estados Unidos.'];
  return <section className="py-24 bg-white text-text-dark border-y border-cream-dark" data-id="element-173">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-24" data-id="element-175">
          {/* IS FOR */}
          <FadeIn direction="right" data-id="element-176">
            <div className="bg-cream p-8 rounded-2xl border-t-4 border-green-500 h-full" data-id="element-177">
              <h3 className="text-2xl font-bold text-navy mb-8 font-serif" data-id="element-178">
                Esto ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-179">
                {isFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-180">
                    <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-181" />
                    <span className="text-text-dark font-sans leading-relaxed" data-id="element-182">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NOT FOR */}
          <FadeIn direction="left" delay={0.2} data-id="element-183">
            <div className="bg-gray-50 p-8 rounded-2xl border-t-4 border-red-400 h-full" data-id="element-184">
              <h3 className="text-2xl font-bold text-text-muted mb-8 font-serif" data-id="element-185">
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-186">
                {notFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-187">
                    <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-188" />
                    <span className="text-text-muted font-sans leading-relaxed" data-id="element-189">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}